export default __webpack_public_path__ + "8af61a012a18c41290aa6a3e1fe891e2.png";